import { EditableReferenceData } from "@/components/admin/ReferenceDataList";
import { TeamProfilePanel } from "@/components/admin/TeamProfilePanel";
import { AgentsPanel } from "@/components/admin/AgentsPanel";
import { EDITABLE_REF_TYPES } from "@/components/admin/reference-data-config";

// "Stammdaten" – what admins maintain themselves, as settings sidebar sub-menus (STAMMDATEN_TABS).
// The things admins author come first: a Power Scorecard carries weights and members, an agent
// two-language prose and repeatable lists, so each renders its own panel. "Auswahlwerte" comes
// last: the flat label/id lookups behind the profile dropdowns, set once and rarely revisited, all
// on one page as a uniform card grid. The lists each organisation fills itself lead, the ones that
// ship pre-filled (industries, degrees, genders, marital statuses) follow — order, not headings,
// does the grouping. (Questionnaires have their own section/role and live in FragebogenPanel.)

export const STAMMDATEN_TABS = [
  { id: "teamprofil", labelId: "stammdaten.teamprofil" },
  { id: "agents", labelId: "stammdaten.agents" },
  {
    id: "values",
    labelId: "stammdaten.values",
    keys: [
      "jobDepartment",
      "jobLocation",
      "contractType",
      "workingTimeModel",
      "industry",
      "degree",
      "gender",
      "maritalStatus",
    ],
  },
] as const;

export type StammdatenTabId = (typeof STAMMDATEN_TABS)[number]["id"];

const byKey = (key: string) => EDITABLE_REF_TYPES.find((t) => t.key === key)!;

export function StammdatenPanel({ active }: { active: StammdatenTabId }) {
  const tab = STAMMDATEN_TABS.find((t) => t.id === active) ?? STAMMDATEN_TABS[0];
  if (tab.id === "teamprofil") return <TeamProfilePanel />;
  if (tab.id === "agents") return <AgentsPanel />;
  return (
    <div className="grid grid-cols-1 items-start gap-6 @md:grid-cols-2">
      {tab.keys.map((key) => (
        <EditableReferenceData key={key} descriptor={byKey(key)} />
      ))}
    </div>
  );
}
